define('viewModels/privileged/qm/ConversationTimelineView',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'jquery',
    'moment',
    'lib/vis',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/util/ConversationTimelineUtil',
    'services/externalContactService',
    'services/userService'
], function(
    ko,
    _,
    Promise,
    $,
    moment,
    vis,
    ViewModel,
    conversationTimelineUtil,
    externalContactService,
    userService
) {
    'use strict';

    var ConversationTimelineView = ViewModel.extend(function(conversationDetailsV6Observable) {
        var self = this;

        self.active = ko.observable(false);
        self.timelineData = new vis.DataSet();
        self.timelineGroups = new vis.DataSet();

        // specify options
        self.timelineOptions = {
            'width': '100%',
            'editable': false, // enable dragging and editing events
            'type': 'range',
            'stack': false,
            'showCurrentTime': true,
            'multiselect': false,
            'locale': ko.i18n.getLocale(),
            'orientation': 'bottom'
        };

        self.setTimeline = function(timeline) {
            self.timeline = timeline;

            // When an timeline item is selected manually trigger a click event on the popover div to display segment details
            self.timeline.on('select', function(properties) {
                // The id of the selected item and manually trigger a click event on the popover element to activate it
                var selectedItemId = properties.items[0];
                $('#' + selectedItemId).trigger('click');
            });

            // When the timeline is panned/zoomed, manually trigger a scroll event to hide any visible popups
            self.timeline.on('rangechange', function() {
                // Trigger the scroll event
                $(window).scroll();
            });
        };

        self.updateLiveSegments = function() {
            if (self.active()) {
                var now = moment();
                self.timelineData.forEach(function(item) {
                    item.end = now;
                    var duration = item.end.diff(item.start);
                    item.duration = conversationTimelineUtil.roundMillisecondsToNearestSecond(duration);

                    self.timelineData.update(item);
                }, {
                    filter: function(item) {
                        return (item.active !== undefined && item.active);
                    }
                });
            }
        };

        var createGroupObject = function (participant, communication) {
            var groupObj = {};

            groupObj.id = conversationTimelineUtil.getParticipantGroup(participant, communication, communication.mediaType);
            groupObj.name = conversationTimelineUtil.getParticipantName(participant);

            groupObj.purpose = conversationTimelineUtil.getParticipantPurpose(participant);
            groupObj.communicationType = communication.mediaType;

            groupObj.addresses = [];
            var similarCommunications = _.filter(participant.sessions, {'mediaType': communication.mediaType});
            groupObj.addresses = _.uniq(_.map(similarCommunications, function (similarCommunication) {
                if (similarCommunication.addressSelf) {
                    return similarCommunication.addressSelf;
                }
                if (similarCommunication.direction === "inbound") {
                    var inboundAddress = similarCommunication.ani || similarCommunication.addressFrom;
                    return ko.i18n.formatPhoneAddress(inboundAddress);
                } else if (similarCommunication.direction === "outbound") {
                    var outboundAddress = similarCommunication.sessionDnis || similarCommunication.dnis || similarCommunication.addressTo;
                    return ko.i18n.formatPhoneAddress(outboundAddress);
                }
            }));

            if (participant.userId !== undefined) {
                groupObj.userId = participant.userId;
            }

            if (participant.externalContactId !== undefined) {
                groupObj.externalContactId = participant.externalContactId;
            }

            if(participant.queueId !== undefined && participant.name !== undefined) {
                groupObj.queueName = participant.name;
            }

            return groupObj;
        };

        var createDataObject = function (groupId, segment, communicationDirection, options) {
            var dataObj = {};

            dataObj.start = moment(segment.segmentStart);
            dataObj.startMs = dataObj.start.valueOf();
            dataObj.group = groupId;
            dataObj.id = dataObj.group + "_" + dataObj.start.valueOf();
            dataObj.segmentType = segment.segmentType;
            dataObj.disconnectType = segment.disconnectType;
            // Support showing message type -- sms, line, facebook twitter
            if (options && options.messageType) {
                dataObj.messageType = options.messageType;
            }

            if (segment.segmentEnd !== undefined) {
                dataObj.end = moment(segment.segmentEnd);
                dataObj.active = false;
            } else {
                dataObj.end = moment();
                dataObj.active = true;
            }
            dataObj.endMs = dataObj.end.valueOf();

            var duration = dataObj.end.diff(dataObj.start);
            dataObj.duration = conversationTimelineUtil.roundMillisecondsToNearestSecond(duration);
            dataObj.direction = communicationDirection;

            // Add a second to the end of segments with 0 duration (after duration has been
            // calculated) so that it can be displayed.
            if (segment.segmentStart === segment.segmentEnd) {
                dataObj.end = dataObj.end.add(1, 'second');
            }

            dataObj.className = "segment-type-" + segment.segmentType;

            return dataObj;
        };

        var cachedUsers = {};
        var getCachedUser = function(userId) {
            if (cachedUsers[userId]) {
                return Promise.resolve(cachedUsers[userId]);
            } else {
                return userService.getUser(userId)
                .then(function (user) {
                    cachedUsers[userId] = user;
                    return user;
                });
            }
        };

        self.computed(function() {
            var conversation = ko.toJS(conversationDetailsV6Observable);
            if (conversation) {
                var isActive = conversationTimelineUtil.isConversationActive(conversation);
                self.active(isActive);

                self.timelineOptions.showCurrentTime = isActive;

                if (conversation.participants) {
                    _.each(conversation.participants, function (participant) {
                        _.each(participant.sessions, function (communication) {

                            var groupObj = createGroupObject(participant, communication);
                            self.timelineGroups.update(groupObj);

                            if (communication.segments) {
                                _.each(communication.segments, function (segment) {
                                    // Support showing message type -- sms, line, facebook twitter
                                    var dataObj = createDataObject(groupObj.id, segment, communication.direction, { 'messageType': communication.messageType });
                                    self.timelineData.update(dataObj);
                                });
                            }
                        });
                    });

                    // Get the distinct list of groups with segments
                    var groupsWithSegments = self.timelineData.distinct("group");
                    var groupIds = self.timelineGroups.getIds();
                    var emptyGroups = _.difference(groupIds, groupsWithSegments);

                    self.timelineGroups.remove(emptyGroups);

                    self.timelineGroups.forEach(function(group) {
                        getCachedUser(group.userId)
                            .then(function(user) {
                                if (user.name) {
                                    group.name = user.name;
                                    self.timelineGroups.update(group);
                                }
                            });
                    }, {
                        filter: function(group) {
                            return (group.userId && group.userImage === undefined);
                        }
                    });

                    self.timelineGroups.forEach(function(group) {
                        // A bug allowed external contact to get set on some agent participants. If
                        // this is an agent, don't expand the contact. Just use the user name info.
                        if (!group.userId) {
                            externalContactService.getCachedExternalContact(group.externalContactId)
                                .then(function(externalContact) {
                                    if (externalContact.firstName && externalContact.lastName) {
                                        group.name = ko.i18n.renderString({
                                            'name': 'conversationDetails.externalContact.nameFormat',
                                            'data': {
                                                'firstName': externalContact.firstName,
                                                'lastName': externalContact.lastName
                                            }
                                        });
                                        self.timelineGroups.update(group);
                                    }
                                });
                        }
                    }, {
                        filter: function(group) {
                            return (group.externalContactId);
                        }
                    });
                }
            }
        });
    });
    return ConversationTimelineView;
});

